<div class="app-container">
  <loading-spinner [isLoading]="loading()" [classesString]="'top-50'"></loading-spinner>
  <page-header
    [icon]="'far-file-check'"
    [title]="isCreating() ? 'inventory.new' : !!queryInventoryExport.data() ? 'inventory.detail' : ''"
    [appendNoTranslationTitlePart]="
      queryInventoryExport.data()?.date ? (queryInventoryExport.data().date | strToDate | date: 'dd.MM.yyyy') : ''
    "
  >
    <ng-container class="header-button">
      @if (
        inventoryExportForm.value.generated &&
        !queryInventoryExport.data()?.approved &&
        !inventoryExportForm.value.rejected
      ) {
        <btn
          [label]="'download'"
          [title]="'download' | translate"
          [classes]="['btn-first', 'float-right']"
          [icon]="'fa-download'"
          (onEvent)="downloadGenerated()"
          [spinnerClassesString]="'spinner-white'"
        ></btn>
      }
    </ng-container>
  </page-header>

  @if (queryInventoryExport.data()) {
    <section class="content">
      <div class="card">
        <div class="card-body">
          <div>
            <div class="row">
              <div class="col-sm-6">
                <div class="row margin-bottom-sm">
                  <div class="col-sm-3">{{ 'dateCreated' | translate }}:</div>
                  <div class="col-sm-9">
                    {{
                      queryInventoryExport.data()?.created
                        ? (queryInventoryExport.data()?.created | strToDate | date: 'dd.MM.yyyy HH:mm')
                        : ''
                    }}
                  </div>
                </div>
                <div class="row margin-bottom-sm">
                  <div class="col-sm-3">{{ 'reports.date.state' | translate }}:</div>
                  <div class="col-sm-9">
                    {{
                      queryInventoryExport.data()?.date
                        ? (queryInventoryExport.data()?.date | strToDate | date: 'dd.MM.yyyy')
                        : ''
                    }}
                  </div>
                </div>
                @if (queryInventoryExport.data()?.approved) {
                  <div class="row margin-bottom-sm">
                    <div class="col-sm-3">{{ 'reports.dateApproved' | translate }}:</div>
                    <div class="col-sm-9">
                      {{
                        queryInventoryExport.data()?.approved
                          ? (queryInventoryExport.data()?.approved | strToDate | date: 'dd.MM.yyyy HH:mm')
                          : ''
                      }}
                    </div>
                  </div>
                }
                @if (inventoryExportForm.value.rejected) {
                  <div class="row margin-bottom-sm">
                    <div class="col-sm-3">{{ 'reports.dateRejected' | translate }}:</div>
                    <div class="col-sm-9">
                      {{
                        inventoryExportForm.value.rejected
                          ? (inventoryExportForm.value.rejected | strToDate | date: 'dd.MM.yyyy HH:mm')
                          : ''
                      }}
                    </div>
                  </div>
                }
                @if (queryInventoryExport.data()?.depots && queryInventoryExport.data()?.depots.length > 0) {
                  <div class="row margin-bottom-sm">
                    <div class="col-sm-3">{{ 'reports.depots' | translate }}:</div>
                    <div class="col-sm-9">
                      @for (depot of queryInventoryExport.data()?.depots; track depot) {
                        <span class="label label-default">
                          {{ depot.name }}
                        </span>
                      }
                    </div>
                  </div>
                }
                @if (queryInventoryExport.data().suppliers && queryInventoryExport.data()?.suppliers.length > 0) {
                  <div class="row margin-bottom-sm">
                    <div class="col-sm-3">{{ 'reports.suppliers' | translate }}:</div>
                    <div class="col-sm-9">
                      @for (supplier of queryInventoryExport.data()?.suppliers; track supplier) {
                        <span class="label label-default">
                          {{ supplier.name }}
                        </span>
                      }
                    </div>
                  </div>
                }
                @if (queryInventoryExport.data()?.producers && queryInventoryExport.data()?.producers.length > 0) {
                  <div class="row margin-bottom-sm">
                    <div class="col-sm-3">{{ 'brands' | translate }}:</div>
                    <div class="col-sm-9">
                      @for (producer of queryInventoryExport.data()?.producers; track producer) {
                        <span class="label label-default">
                          {{ producer.name }}
                        </span>
                      }
                    </div>
                  </div>
                }
                @if (!isGeneratedFinal()) {
                  <div class="row margin-bottom-sm">
                    <div class="col-sm-3">{{ 'inventory.file.generated.1' | translate }}:</div>
                    <div class="flex-gap-1">
                      @if (inventoryExportForm.value?.generated) {
                        <btn
                          [label]="'download'"
                          [title]="'download' | translate"
                          [classes]="['btn-first', 'btn-sm']"
                          [icon]="'fa-download'"
                          (onEvent)="downloadGenerated()"
                        ></btn>
                      }
                      @if (!inventoryExportForm.value?.generated) {
                        <button class="btn btn-second btn-sm" disabled>
                          <i class="fa fa-spinner fa-spin margin-right"></i>
                          {{ 'reports.generating' | translate }}
                        </button>
                      }
                      @if (
                        inventoryExportForm.value?.generated &&
                        !inventoryExportForm.value?.approved &&
                        !inventoryExportForm.value?.rejected
                      ) {
                        <btn
                          [title]="'inventory.refresh' | translate"
                          [classes]="['btn-third', 'float-right', 'me-2', 'margin-left']"
                          [icon]="'fas fa-sync-alt'"
                          (onEvent)="refreshExportInventory.mutate()"
                          [spinnerClassesString]="'spinner-white'"
                        >
                        </btn>
                      }
                    </div>
                  </div>
                }
                @if (
                  inventoryExportForm.value.generated &&
                  !queryInventoryExport.data().approved &&
                  !inventoryExportForm.value.rejected
                ) {
                  <div class="row margin-bottom-sm">
                    <div class="col-sm-3">{{ 'inventory.file.upload' | translate }}:</div>
                    <div class="col-sm-9">
                      <form-row-input
                        [icon]="'fa-upload'"
                        [inputType]="'file'"
                        [inputAccept]="inventoryUploadAccept"
                        [dataCyAttribute]="'inventory-upload-file'"
                        (valueChangeNative)="handleFileUpload($event)"
                      ></form-row-input>
                    </div>
                  </div>
                }
                @if (isGeneratedFinal()) {
                  <div class="row margin-bottom-sm">
                    <div class="col-sm-3">{{ 'inventory.file.generated.2' | translate }}:</div>
                    <div class="col-sm-9">
                      @if (queryInventoryExport.data().generated) {
                        <btn
                          [label]="'download'"
                          [title]="'download' | translate"
                          [classes]="['btn-first', 'btn-sm']"
                          [icon]="'fa-download'"
                          (onEvent)="downloadGeneratedFinal()"
                        ></btn>
                      }
                      @if (!queryInventoryExport.data().generated) {
                        <button class="btn btn-second btn-sm" disabled>
                          <i class="fa fa-spinner fa-spin margin-right"></i>
                          {{ 'reports.generating' | translate }}
                        </button>
                      }
                    </div>
                  </div>
                }
              </div>
              @if (
                queryInventoryExport.data().files &&
                queryInventoryExport.data().files.length > 0 &&
                inventoryExportForm.value.generated
              ) {
                <div class="col-sm-6 flexbox-centered-col mh-15rem">
                  @if (!queryInventoryExport.data().approved && !inventoryExportForm.value.rejected) {
                    <div class="margin-bottom">
                      <btn
                        [label]="'inventory.btn.approve'"
                        [title]="'inventory.btn.approve' | translate"
                        [classes]="['btn-first', 'btn-lg']"
                        [icon]="'fa fa-check-square'"
                        (onEvent)="approveInventory()"
                      ></btn>
                    </div>
                  }
                  @if (!queryInventoryExport.data().approved && !inventoryExportForm.value.rejected) {
                    <div class="margin-bottom">
                      <btn
                        [label]="'inventory.btn.reject'"
                        [title]="'inventory.btn.reject' | translate"
                        [classes]="['btn-first-red', 'btn-lg']"
                        [icon]="'far-trash-alt'"
                        (onEvent)="rejectInventory()"
                      ></btn>
                    </div>
                  }
                  @if (queryInventoryExport.data().approved) {
                    <div class="margin-bottom">
                      <btn
                        [label]="'inventory.approved'"
                        [title]="'inventory.approved' | translate"
                        [classes]="['btn-first', 'btn-lg']"
                        [icon]="'fa fa-check-square'"
                        [btnDisabled]="true"
                      ></btn>
                    </div>
                  }
                  @if (inventoryExportForm.value.rejected) {
                    <div class="margin-bottom">
                      <btn
                        [label]="'inventory.rejected'"
                        [title]="'inventory.rejected' | translate"
                        [classes]="['btn-first-red', 'btn-lg']"
                        [icon]="'far-trash-alt'"
                        [btnDisabled]="true"
                      ></btn>
                    </div>
                  }
                  @if (
                    queryInventoryExport.data().approved &&
                    !queryInventoryExport.data().pmpIn &&
                    !queryInventoryExport.data().pmpOut &&
                    !this.isGeneratedPmps()
                  ) {
                    <div class="margin-bottom">
                      <button class="btn btn-second" disabled>
                        <i class="fa fa-spinner fa-spin margin-right"></i>
                        {{ 'reports.generating' | translate }}
                      </button>
                    </div>
                  }
                  @if (
                    queryInventoryExport.data().approved &&
                    queryInventoryExport.data().pmpIn &&
                    queryInventoryExport.data().pmpIn.url &&
                    queryInventoryExport.data().pmpIn.url.length > 0
                  ) {
                    <div class="margin-bottom">
                      <btn
                        [label]="'download.pmp.in'"
                        [title]="'download.pmp.in' | translate"
                        [classes]="['btn-first', 'btn-lg']"
                        [icon]="'fa-download'"
                        (onEvent)="downloadProductMovePack(queryInventoryExport.data().pmpIn)"
                      ></btn>
                    </div>
                  }
                  @if (
                    queryInventoryExport.data().approved &&
                    queryInventoryExport.data().pmpOut &&
                    queryInventoryExport.data().pmpOut.url &&
                    queryInventoryExport.data().pmpOut.url.length > 0
                  ) {
                    <div class="margin-bottom">
                      <btn
                        [label]="'download.pmp.out'"
                        [title]="'download.pmp.out' | translate"
                        [classes]="['btn-first', 'btn-lg']"
                        [icon]="'fa-download'"
                        (onEvent)="downloadProductMovePack(queryInventoryExport.data().pmpOut)"
                      ></btn>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
          <div>
            @if (error) {
              <alert type="danger">
                {{ 'print-inventory.error' | translate }}
              </alert>
            }
          </div>
        </div>
      </div>
    </section>
  }
</div>
